import { Component, OnInit, ViewChild, Inject, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalComponent } from '../../global/global.component';
import { FilterSettingsModel, IFilter, GridComponent, DataStateChangeEventArgs, QueryCellInfoEventArgs } from '@syncfusion/ej2-angular-grids';
import { DropDownList } from '@syncfusion/ej2-angular-dropdowns';
import { SearchSettingsModel, ToolbarItems } from '@syncfusion/ej2-grids';
import { casemanagerHTTPService } from './case-manager.service';
import { caseManagerList, sortingObj, GetCaseListBo, WhereCondition, columnWidth, functionpermission } from './case-manager.model';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/service/general.service';
import { GetHTTPService } from './case-table.service';
import { Observable } from 'rxjs/Observable';
import { Tooltip } from '@syncfusion/ej2-angular-popups';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonHttpService } from 'src/app/common.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-case-manager',
  templateUrl: './case-manager.component.html',
  styleUrls: ['./case-manager.component.scss'],
})

export class CaseManagerComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  fp: functionpermission = new functionpermission();

  //========================Main Functionality==========================//
  @Input() fromClient: string;
  @Output() emitcasemanger = new EventEmitter<number>()
  conditionData: WhereCondition = new WhereCondition();
  Case: caseManagerList = new caseManagerList();
  CaseSendBO: GetCaseListBo = new GetCaseListBo();
  SaveList: caseManagerList = new caseManagerList();
  isSaveorUpdateBoolean:boolean=false;
  conditionlist: WhereCondition[] = [];
  CaseArray: caseManagerList[];
  ColumnArray: columnWidth[]
  //columnchange: ColumnChangeBO = new ColumnChangeBO();
  id: string;
  arraycol: any = [];
  // ========================Form Initialization========================//
  CaseForm: FormGroup;
  // ================================Filters===========================//
  filterItems: { [key: string]: string } = {
    'Name': 'Name',
    'Street': 'Street',
    'state': 'state',
    'City': 'City',
    'Zip': 'Zip'
  };

  SearchText: string = '';
  SearchColumn: { [key: string]: string } = { 'name': 'name' };

  ///////////////-===================Table initializations==========// 
  dropInstance: DropDownList;
  public searchSettings: SearchSettingsModel;
  public toolbar: ToolbarItems[];
  initialPage: object;
  filterOptions: FilterSettingsModel;
  ///////////////================Column chooser initializations=================////////
  @ViewChild('grid') public grid: GridComponent;
  ///////////////================Column chooser=================////////
  filter: IFilter;
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  //============================Data manager===============================//
  public isinitialLoad: boolean = false;
  //======================================new try====================//
  public data: Observable<DataStateChangeEventArgs>;
  public state: DataStateChangeEventArgs;
  // =============================other initialization======================= //
  TotalCount: number;
  pagshort: sortingObj = new sortingObj();
  ModelType: string = 'edit';
  valuechange: any = [];
  stateList: any = [];
  type: string = "";
  agencyid_boll = false;
  public ContactId: string;
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  constructor(private formBuilder: FormBuilder, @Inject(GetHTTPService) public gethttp: GetHTTPService,
    public global: GlobalComponent, public httpService: casemanagerHTTPService, private ngxService: NgxUiLoaderService,
    public toastrService: ToastrService, public general: GeneralService, public commonhttp: CommonHttpService) {
    this.global.checkforlogout();
    this.data = gethttp;
    this.CaseForm = this.formBuilder.group({
      name: [' '],
      street: ['',],
      state: [''],
      city: [''],
      zip: ['', Validators.required],
      Email: ['', Validators.email],
      phone: ['', [Validators.minLength(14), Validators.maxLength(14)]],
      fax: ['', [Validators.minLength(14), Validators.maxLength(14)]],
    });
  }

  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.CaseSendBO.orderColumn = state.sorted[0].name;
        this.CaseSendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.CaseSendBO.field = state.action.currentFilterObject.field;
      this.CaseSendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.CaseSendBO.operator = state.action.currentFilterObject.operator;
      this.CaseSendBO.value = state.action.currentFilterObject.value;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.CaseSendBO.field = "name";
        this.CaseSendBO.matchCase = false;
        this.CaseSendBO.operator = "startswith";
        this.CaseSendBO.value = "";
      }
    }
    this.getCase();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Casemanager.Pagesize != state.take) {
          this.arraycol[0].Casemanager.Pagesize = state.take
        }

      }
    }
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ngOnInit(): void {
    if (
      (this.global.globalAgencyId == null ||
        this.global.globalAgencyId == undefined ||
        this.global.globalAgencyId == "" ||
        this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") && (this.global.agencyCode == 'SUPERADMIN')) {
      return;
    }
    if (this.global.globalAgencyId) {
      this.agencyid_boll = true

    }
    else {
      this.agencyid_boll = false

    }
    this.conditionlist.push(new WhereCondition());
    this.toolbar = ['ColumnChooser'];
    this.SearchColumn.key = 'name';
    this.SearchColumn.value = 'name';
    this.getCase();
    this.filterOptions = { type: 'Menu' };
    this.initialPage = {
      currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0],
      pageSizes: this.pageSizes
    };
    this.commonhttp.getJSON().pipe(takeUntil(this.onDestroy$)).subscribe(data => {
      this.stateList = data;
    });
    this.getpermission();
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId != null && this.global.globalAgencyId != undefined && this.global.globalAgencyId != '')) {
      let params = new URLSearchParams();
      params.append("pagecode", "Casemanager");
      params.append("roleId", this.global.roleId);
      params.append("agencyId", this.global.globalAgencyId)
      this.httpService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        if (data != null) {
          this.fp = data;
        }
        else {
          this.fp = new functionpermission();
        }
      },
        (err: HttpErrorResponse) => {
          this.fp = new functionpermission();
        })
    }
  }

  // =======================================================
  onActionBegin(args) {
  }

  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {
        this.arraycol[0].Casemanager.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });

        this.arraycol[0].Casemanager.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });

        if (this.arraycol[0].Casemanager.ShowColumns.length != count1 || this.arraycol[0].Casemanager.HideColumns.length != count) {
          this.arraycol[0].Casemanager.ShowColumns = showarr;
          this.arraycol[0].Casemanager.HideColumns = hidearr;
        }
      }
    }
    this.CaseSendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.CaseSendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
    this.conditionlist = [];
    if (args.requestType === "filtering" && args.action === "filter") {
      args.columns.forEach(element => {
        this.conditionlist.push(element.properties);
      });
    }
  }

  /////////////////////////////////////////////////////////
  CaseCreateupdate(data) {
    this.ModelType = data;
    if (this.ModelType == 'new') {
      this.CaseForm.reset();
      this.Case = new caseManagerList();
      this.valueschanges();
    }
    else {
      this.valueschanges();
      this.ModelType = 'edit';
    }
  }

  selectCasedetails(caseDetails: caseManagerList) {
    this.Case = JSON.parse(JSON.stringify(caseDetails));
  }
  // =======================Grid Column selector ================ //
  show() {
    this.grid.columnChooserModule.openColumnChooser(500, 50);
  }
  /////////////////////////////////////////////////////////
  DemographicPhoneFormat(value) {
    if (value == 'phone') {
      this.Case.phone = this.general.converPhoneGoogleLib(this.Case.phone);
    }
  }

  DemographicPhoneFormat1(value) {
    if (value == 'fax') {
      this.Case.fax = this.general.converPhoneGoogleLib(this.Case.fax);
    }
  }

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  /////////////////////////////////////////////////////////
  Refresh() {
    this.SearchText = "";
    this.CaseSendBO.field = 'name';
    this.CaseSendBO.value = "";
    this.CaseSendBO.pageitem = 10;
    this.CaseSendBO.currentpageno = 1;
    this.pagshort = new sortingObj();
    this.getCase();
  }
  /////////////////////////////////////////////////////////
  Search() {
    this.CaseSendBO.field = this.SearchColumn.key;
    this.CaseSendBO.value = this.SearchText;
    this.CaseSendBO.pageitem = 10;
    this.CaseSendBO.currentpageno = 1;
    this.pagshort.currentPgNo = 1;
    this.getCase();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  SaveOrUpdateCase(type: string) {
    this.isSaveorUpdateBoolean=true;
    var saveList: caseManagerList = JSON.parse(JSON.stringify(this.Case));
    saveList.id = this.Case.id;
    saveList.phone = this.general.reconverPhoneGoogleLib(saveList.phone);
    saveList.fax = this.general.reconverPhoneGoogleLib(saveList.fax);

    this.httpService.saveupdate(saveList).pipe(takeUntil(this.onDestroy$)).subscribe((data: string) => {

      this.isSaveorUpdateBoolean=false;
      if (data) {
        this.valueschanges();
        this.SaveList.id = data;
        if (this.ModelType == 'new') {
          this.toastrService.success('Case Manager Saved Successfully', 'Case Manager Saved');
          document.getElementById('opencasemanModal1').click();
          this.getCase();
        }
        else {
          this.toastrService.success('Case Manager Updated Successfully', 'Case Manager Updated');
          document.getElementById('opencasemanModal1').click();
          this.getCase();
        }

      }
    }, (err: any) => {
      this.isSaveorUpdateBoolean=false;
      if (err) {
        this.toastrService.error(err.error, 'Error'), 8000;
      }
    })
  }
  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
   setDeleteId(value) {
    this.ContactId = value;
  }

  Delete() {
    let param = new URLSearchParams()
    param.append("id", this.ContactId)
    this.httpService.delete(param).subscribe((_data: any) => {
      this.toastrService.success("casemanager has been deleted successfully", "casemanager deleted");
      document.getElementById("deletemodal").click();
      this.getCase();
    },
      err => {
        this.toastrService.error(err.error);
      })
  }
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  getCase() {
    this.ngxService.start()
    this.gethttp.execute(this.CaseSendBO);
    let count = 0;
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      count = count + 1;
    })
  }
  ////////======================Close case manager================================///
  closecase() {
    document.getElementById('opencasemanModal1').click();
  }
  /////////////////////////////////////////////////////////
  valueschanges() {
    this.valuechange = {
      Name: 0,
      Street: 0,
      State: 0,
      City: 0,
      Zip: 0,
      Fax: 0,
    }
  }

  checkpopup(value) {
    if (value == "name") {
      this.valuechange.Name++;
    }
    if (value == "street") {
      this.valuechange.Street++;
    } if (value == "state") {
      this.valuechange.State++;
    } if (value == "city") {
      this.valuechange.City++;
    }
    if (value == "zip") {
      this.valuechange.Zip++;
    }
    if (value == "Phone") {
      this.valuechange.Phone++;
    }
    if (value == "fax") {
      this.valuechange.Fax++;
    }
  }

  openDialog() {
    if (this.valuechange.Name > 1 || this.valuechange.Street > 1 ||
      this.valuechange.State > 1 || this.valuechange.City > 1 || this.valuechange.Zip > 1 ||
      this.valuechange.Phone || this.valuechange.Fax) {
      document.getElementById('cancelcasemanmodal').click();
    }
    else {
      document.getElementById('opencasemanModal1').click();
    }
  }

  closeAddUpdateModal() {
    document.getElementById('opencasemanModal1').click();
    document.getElementById('cancelcasemanmodal').click();
  }
  onKeydown(event) {
    if (event.key === "Enter") {
      this.Search();
    }
  }
  setDefaultValue() {
    this.SearchText = "";
    if (this.SearchColumn == undefined)
      this.SearchColumn = {
      };
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  //==============================Event emitter=============================================//
  caseemit(data) {
    this.emitcasemanger.emit(data.id)
  }
    //============================== Tooltip =========================================================//
  headerCellInfo(args) {
    const toolcontent = args.cell.column.headerText;
    const tooltip: Tooltip = new Tooltip({
      content: toolcontent
    });
    tooltip.appendTo(args.node);
  }

  tooltip(args: QueryCellInfoEventArgs) {
    if (args.column.field != null) {
      if (args.data[args.column.field] != null) {
        const tooltip: Tooltip = new Tooltip({
          content: args.data[args.column.field].toString(),
          position: 'RightCenter',
        }, args.cell as HTMLTableCellElement);
      }
    }
  }
  canceldelete() {
    document.getElementById('openModal2').click();
  }

  onResize(args) {
    const column = this.grid.getColumnByField(args.column.field)
    column.width = args.column.width;
    this.ColumnArray.forEach(element => {
      if (element.column == column.headerText) {
        element.width = parseInt(column.width.toString());
      }
    });
  }
  
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }
}

